import config from 'config';
import { http_client } from './api';

const getList = async (
  type = null,
  page = null,
  perPage = null,
  sort = null,
  orderBy = null,
  search = null,
  jenjang_id = null,
  mapel_id = null,
  bab_id = null,
  created_by = null,
  start_date = null,
  end_date = null
) => {
  return http_client
    .get(
      config.apiUrl +
        'file?' +
        `${type ? 'type=' + type : ''}` +
        `${perPage ? '&perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${jenjang_id ? '&jenjang_id=' + jenjang_id : ''}` +
        `${mapel_id ? '&mapel_id=' + mapel_id : ''}` +
        `${bab_id ? '&bab_id=' + bab_id : ''}` +
        `${created_by ? '&created_by=' + created_by : ''}` +
        `${start_date ? '&start_date=' + start_date : ''}` +
        `${end_date ? '&end_date=' + end_date : ''}`
    )
    .then((response) => {
      return response.data;
    });
};
const getListArchive = async (
  type = null,
  page = null,
  perPage = null,
  sort = null,
  orderBy = null,
  search = null,
  jenjang_id = null,
  mapel_id = null,
  bab_id = null,
  created_by = null,
  start_date = null,
  end_date = null
) => {
  return http_client
    .get(
      config.apiUrl +
        'file/archive?' +
        `${type ? 'type=' + type : ''}` +
        `${perPage ? '&perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${jenjang_id ? '&jenjang_id=' + jenjang_id : ''}` +
        `${mapel_id ? '&mapel_id=' + mapel_id : ''}` +
        `${bab_id ? '&bab_id=' + bab_id : ''}` +
        `${created_by ? '&created_by=' + created_by : ''}` +
        `${start_date ? '&start_date=' + start_date : ''}` +
        `${end_date ? '&end_date=' + end_date : ''}`
    )
    .then((response) => {
      return response.data;
    });
};
const create = async (data, onProgress) => {
  return http_client.post(config.apiUrl + 'file', data, null, onProgress).then((response) => {
    return response.data;
  });
};
const read = async (id) => {
  return http_client.get(config.apiUrl + 'file/' + id).then((response) => {
    return response.data;
  });
};
const update = async (id, data, onProgress) => {
  return http_client.post(config.apiUrl + 'file/' + id, data, null, onProgress).then((response) => {
    return response.data;
  });
};
const del = async (id) => {
  return http_client.delete(config.apiUrl + 'file/' + id).then((response) => {
    return response.data;
  });
};

const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'file/status/' + id, data).then((response) => {
    return response.data;
  });
};
const VideoService = {
  getList,
  getListArchive,
  create,
  read,
  update,
  del,
  changeStatus
};

export default VideoService;
